<div class="metrics-container">
  <div class="row g-3">
    <div class="col-lg-6 col-md-6 col-sm-12">
      <div
        class="clickable-metric-card"
        [style.cursor]="!isDataLoading() && organizationId() ? 'pointer' : 'default'"
      >
        <app-metric-card
          [title]="'SLA Adherence'"
          [tooltip]="'Percentage of tickets resolved within SLA timeframes for the selected period'"
          [currentValue]="slaAdherenceData().sla_adherence_pct_current || 'No Data Available'"
          [previousValue]="slaAdherenceData().sla_adherence_pct_previous || 0"
          [valueChange]="slaAdherenceData().sla_adherence_pct_change || 0"
          [isHigherBetter]="true"
          [suffix]="'%'"
          [showLeftBorder]="true"
          [isLoading]="isDataLoading()"
          (click)="onSlaCardClick()"
        >
          <ng-template #loading>
            <div class="skeleton-content">
              <div class="metric-value">
                <kendo-skeleton
                  shape="text"
                  animation="wave"
                  width="60px"
                  height="32px"
                ></kendo-skeleton>
              </div>
              <div class="metric-comparison">
                <kendo-skeleton
                  shape="text"
                  animation="wave"
                  width="150px"
                  height="16px"
                ></kendo-skeleton>
              </div>
              <div class="metric-subtext">
                <kendo-skeleton
                  shape="text"
                  animation="wave"
                  width="80px"
                  height="14px"
                ></kendo-skeleton>
              </div>
            </div>
          </ng-template>
        </app-metric-card>
      </div>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-12">
      <div
        class="clickable-metric-card"
        [style.cursor]="!isDataLoading() && organizationId() ? 'pointer' : 'default'"
      >
        <app-metric-card
          [title]="'Event Reduction'"
          [tooltip]="
            'An indicator of SOC value through the reduction of work required by customer input. This is calculated as the percentage difference between the total number of ingested events and the number of escalations (aka: tickets) for customer input.'
          "
          [currentValue]="eventsVsEscalationsChartData().current_reduction_percentage"
          [previousValue]="eventsVsEscalationsChartData().previous_reduction_percentage"
          [valueChange]="eventsVsEscalationsChartData().reduction_percentage_change"
          [suffix]="'%'"
          [isHigherBetter]="true"
          [showLeftBorder]="true"
          [isLoading]="isDataLoading()"
          (click)="onChartClick($event)"
        >
          <ng-template #loading>
            <div class="skeleton-content">
              <div class="metric-value">
                <kendo-skeleton
                  shape="text"
                  animation="wave"
                  width="60px"
                  height="32px"
                ></kendo-skeleton>
              </div>
              <div class="metric-comparison">
                <kendo-skeleton
                  shape="text"
                  animation="wave"
                  width="150px"
                  height="16px"
                ></kendo-skeleton>
              </div>
              <div class="metric-subtext">
                <kendo-skeleton
                  shape="text"
                  animation="wave"
                  width="80px"
                  height="14px"
                ></kendo-skeleton>
              </div>
            </div>
          </ng-template>
        </app-metric-card>
      </div>
    </div>
  </div>
  <div class="row g-3 mt-3">
    <div class="col-12">
      <div class="chart-header d-flex justify-content-between align-items-center mb-3">
        <h5 class="mb-0 d-flex align-items-center gap-2">
          Events vs Escalations
          <kendo-svg-icon
            [icon]="infoCircleIcon"
            size="small"
            class="info-icon"
            kendoTooltip
            title="Daily comparison of total security events received versus events escalated for investigation"
          ></kendo-svg-icon>
        </h5>
        <kendo-dropdownbutton
          kendoButton
          [svgIcon]="moreVerticalIcon"
          [fillMode]="'flat'"
          [size]="'small'"
          [data]="[{ text: 'View Chart Data' }]"
          (itemClick)="onChartClick($event)"
        ></kendo-dropdownbutton>
      </div>
      <div class="chart-container">
        <div
          echarts
          [options]="chartOptions()"
          [initOpts]="{ renderer: 'canvas' }"
          style="height: 350px; width: 100%"
        ></div>
      </div>
    </div>
  </div>

  <!-- Dialog is rendered by the parent (SOC) component to avoid layout clipping -->
</div>
